// extracted by mini-css-extract-plugin
export default {"Container":"ItemStatsSelector_Container__kAp0Y","Row":"ItemStatsSelector_Row__7dPLl","Text":"ItemStatsSelector_Text__rHOGj"};